import StatisticsChart from './statisticsChart.html';

const target = document.getElementById('company-statistics-chart');
if (target) {
  new StatisticsChart({ target, data: JSON.parse(target.dataset.statistics) });
}
